import { apiClient } from "@/api/api-client";
import type { Bir2307AgingResponse, Bir2307Certificate, CreateBir2307Input } from "./types";

interface PaginatedBir2307Response {
	data: Bir2307Certificate[];
	meta: { current_page: number; last_page: number; total: number; per_page: number };
}

export const bir2307Service = {
	list: async (params: Record<string, unknown> = {}) => {
		const res = await apiClient.get<PaginatedBir2307Response>("bir-2307", { params });
		return res.data;
	},
	get: async (id: string) => {
		const res = await apiClient.get<{ data: Bir2307Certificate }>(`bir-2307/${id}`);
		return res.data.data;
	},
	create: async (input: CreateBir2307Input) => {
		const res = await apiClient.post<{ data: Bir2307Certificate }>("bir-2307", input);
		return res.data.data;
	},
	update: async (id: string, input: CreateBir2307Input) => {
		const res = await apiClient.put<{ data: Bir2307Certificate }>(`bir-2307/${id}`, input);
		return res.data.data;
	},
	delete: async (id: string) => {
		await apiClient.delete(`bir-2307/${id}`);
	},
	verify: async (id: string) => {
		const res = await apiClient.post<{ data: Bir2307Certificate }>(`bir-2307/${id}/verify`);
		return res.data.data;
	},
	file: async (id: string, filing_reference?: string) => {
		const res = await apiClient.post<{ data: Bir2307Certificate }>(`bir-2307/${id}/file`, {
			filing_reference,
		});
		return res.data.data;
	},
	aging: async () => {
		const res = await apiClient.get<Bir2307AgingResponse>("bir-2307/aging");
		return res.data;
	},
};
